import styled from 'styled-components';

import { remify } from '#/service/utils';

export interface BannerProps {
  /** Is this an error style notification? */
  error: boolean;
  /** A flag to show the banner or keep it hidden */
  hidden?: boolean;
  /** Text displayed in the banner */
  message: string;
}

interface BannerDivProps {
  /** Is this an error style notification? */
  $error: boolean;
}

const BannerContainer = styled.div<BannerDivProps>`
  background-color: ${({ $error }) =>
    $error
      ? `var(--bannerExceptionBackground)`
      : `var(--bannerInfoBackground)`};
  color: ${({ $error }) =>
    $error
      ? `var(--bannerExceptionForeground)`
      : `var(--bannerInfoForeground)`};
  font: var(--fontStyleCallout);
  text-align: center;
  padding: ${remify(24)} 0;
`;

const Banner = ({ error, hidden, message }: BannerProps) => {
  return hidden ? null : (
    <BannerContainer $error={error} role="status">
      {message}
    </BannerContainer>
  );
};

export default Banner;
